import Vue from 'vue';
import Component from 'vue-class-component';
import {Mixins} from 'vue-property-decorator';
import {BoardUsersMixin} from '@/mixins/common/board-users.mixin';

@Component({})
class EdBoardTaskUsers extends Mixins(BoardUsersMixin) {

    get canJoin(): boolean {
        return this.isHomeworkOwnerConnected;
    }

    public join(): void {
        this.$emit('teacher-joined-homework');
    }
}

export default Vue.component('ed-board-task-users', EdBoardTaskUsers);